export { getPartnerships } from './api/get-partnerships'
export { getEvents } from './api/get-events'
export { getCampaignDetail } from './api/get-campaign-detail'
export { getArticles } from './api/get-articles'
export { getEditorPickArticles } from './api/get-editor-pick-articles'
export type {
  TPartnership,
  TEvent,
  TCampaignDetail,
  TArticle,
  TArticleCategory,
  TEditorPickArticle,
} from './model/schema'
export { CampaignType } from './model/schema'
export { campaignQueries } from './api/query'
export { CAMPAIGN_DETAIL } from './mock/get-campaign-detail/data'
